import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { Injectable } from '@angular/core';
import { PlessHttp } from '../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { KYMW00Model } from '../../kymw00/kymw00.model';

/**
 * 列幅設定取得サービス
 * @export GetUserColumnWidthSettingsService
 * @class GetUserColumnWidthSettingsService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetUserColumnWidthSettingsService extends PlessJsonResponderSub<any> {
  private calbak: (data) => void;
  private vo = {
    userId: '',
    gridId: ''
  }

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub,
    public kymw00Model: KYMW00Model,
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetUserColumnWidthSettingsService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        UserId: this.vo.userId,
        GridId: this.vo.gridId
      },
    });
  }

  /**
   * API呼び出し
   *
   * @param vo
   * @param f コールバック
   * @memberof GetUserColumnWidthSettingsService
   */
  execute(vo: any, f: (data) => void = null): void {
    this.vo = vo
    this.calbak = f;
    this.send('getUserColumnWidthSettings', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetUserColumnWidthSettingsService
   */
  success(data: any) {
    if (this.calbak) this.calbak(data);
  }
}
